import { useFormContext } from 'react-hook-form';

import type { FormDatePickerProps } from '../types';
import type { FieldValues } from 'react-hook-form';

import { DatePicker } from '@/components/DatePicker';
import { Field, FieldDescription, FieldError } from '@/components/ui/field';
import { FormField } from '@/components/ui/form';

import { DISPLAY_DATES_FORMAT, SEND_DATES_FORMAT } from '@/constants/dates';

export const FormDatePicker = <TFieldValues extends FieldValues = FieldValues>(
  props: FormDatePickerProps<TFieldValues>,
) => {
  const {
    name,
    label,
    description,
    isRequired,
    dateFormat = SEND_DATES_FORMAT,
    displayDateFormat = DISPLAY_DATES_FORMAT,
    control,
    showYearDropdown = true,
  } = props;
  const formContext = useFormContext<TFieldValues>();
  const formControl = control || formContext.control;

  const fieldId = `form-field-${String(name)}`;

  return (
    <FormField
      control={formControl}
      name={name}
      render={({ field, fieldState }) => {
        const fieldLabel = (
          <>
            {label}
            {isRequired && (
              <span
                className={
                  fieldState.invalid
                    ? 'text-destructive'
                    : 'text-muted-foreground'
                }
              >
                *
              </span>
            )}
          </>
        );

        return (
          <Field data-invalid={fieldState.invalid}>
            <DatePicker
              showYearDropdown={showYearDropdown}
              id={fieldId}
              value={field.value || ''}
              onChange={field.onChange}
              label={fieldLabel}
              dateFormat={dateFormat}
              displayDateFormat={displayDateFormat}
              aria-invalid={fieldState.invalid}
            />
            {fieldState.invalid && <FieldError errors={[fieldState.error]} />}
            {description && <FieldDescription>{description}</FieldDescription>}
          </Field>
        );
      }}
    />
  );
};
